/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserFieldsFragment = { __typename: 'User', last_name: string, first_name: string, email: string, id: string, assigned_campaigns: Array<{ __typename: 'Campaign', id: string | null, label_id: string | null }> | null };

export type GetSuccessStoriesQueryVariables = Types.Exact<{
  offset: Types.InputMaybe<Types.Scalars['Int']>;
  limit: Types.InputMaybe<Types.Scalars['Int']>;
  filters: Types.InputMaybe<Types.InboxFilters>;
}>;


export type GetSuccessStoriesQuery = { __typename: 'Query', getGlobalInbox: { __typename: 'GlobalInboxResponse', total: number, items: Array<{ __typename: 'GlobalInboxItem', updated_at: string | null, created_at: string | null, argument_id: number | null, id: string | null, message: string | null, review_status: Types.ReviewStatus | null, user_id: number | null, story: { __typename: 'Feed', editable: boolean, gallery: Array<string> | null, id: string, body: string | null, title: string, argument_type: string, created_at: string, updated_at: string, global_status: Types.GlobalStatus | null, properties: string | null, product_id: string | null, campaign_id: number, review_status: Types.ReviewStatus | null, inboxId: string | null, tags: Array<{ __typename: 'Tag', id: string, label: string, order_number: number }> | null, lastEditor: { __typename: 'User', last_name: string, first_name: string, email: string, id: string, assigned_campaigns: Array<{ __typename: 'Campaign', id: string | null, label_id: string | null }> | null } | null, author: { __typename: 'User', last_name: string, first_name: string, email: string, id: string, assigned_campaigns: Array<{ __typename: 'Campaign', id: string | null, label_id: string | null }> | null } | null, product: { __typename: 'Product', name: string | null, configuration: string | null } | null, facts: { __typename: 'Fact', chart: string | null, position_current_at: string | null } | null, campaign: { __typename: 'Campaign', id: string | null, name: string | null, owner_id: number | null, unit_id: number | null, label_id: string | null, active: boolean | null, unit: { __typename: 'Unit', id: string, name: string, alias: string } | null }, artist: { __typename: 'Artist', id: string | null, name: string | null, spotify_id: string | null, facebook_id: string | null }, comments: Array<{ __typename: 'Comment', id: string, text: string, updated_at: string, campaign_id: number, author: { __typename: 'User', first_name: string, last_name: string, label_id: string | null } }> | null } | null }> } | null };

export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  last_name
  first_name
  email
  id
  assigned_campaigns {
    id
    label_id
  }
}
    `;
export const GetSuccessStoriesDocument = gql`
    query getSuccessStories($offset: Int, $limit: Int, $filters: InboxFilters) {
  getGlobalInbox(limit: $limit, offset: $offset, filters: $filters) {
    total
    items {
      updated_at
      created_at
      argument_id
      id
      message
      review_status
      user_id
      story {
        editable
        gallery
        id
        body
        title
        argument_type
        created_at
        updated_at
        global_status
        properties
        product_id
        campaign_id
        review_status
        inboxId
        tags {
          id
          label
          order_number
        }
        lastEditor {
          ...UserFields
        }
        author {
          ...UserFields
        }
        product {
          name
          configuration
        }
        facts {
          chart
          position_current_at
        }
        campaign {
          id
          name
          owner_id
          unit_id
          label_id
          active
          unit {
            id
            name
            alias
          }
        }
        artist {
          id
          name
          spotify_id
          facebook_id
        }
        comments {
          id
          text
          updated_at
          campaign_id
          author {
            first_name
            last_name
            label_id
          }
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetSuccessStoriesQuery__
 *
 * To run a query within a React component, call `useGetSuccessStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuccessStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuccessStoriesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSuccessStoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetSuccessStoriesQuery, GetSuccessStoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuccessStoriesQuery, GetSuccessStoriesQueryVariables>(GetSuccessStoriesDocument, options);
      }
export function useGetSuccessStoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuccessStoriesQuery, GetSuccessStoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuccessStoriesQuery, GetSuccessStoriesQueryVariables>(GetSuccessStoriesDocument, options);
        }
export type GetSuccessStoriesQueryHookResult = ReturnType<typeof useGetSuccessStoriesQuery>;
export type GetSuccessStoriesLazyQueryHookResult = ReturnType<typeof useGetSuccessStoriesLazyQuery>;